import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TypedFormBuilder, TypedFormGroup } from '@gmrappdev/formsafe';
import { PilotViewModel, PrdProcessingState } from 'src/view-models/pilot-view-model';

export const PrdProcessingStateSelectItems = [
  { value: PrdProcessingState.Draft, selectable: true },
  { value: PrdProcessingState.ReadyForTransmission, selectable: true },
  { value: PrdProcessingState.Queued, selectable: false },
  { value: PrdProcessingState.TransmissionInProgress, selectable: false },
  { value: PrdProcessingState.TransmissionError, selectable: false },
  { value: PrdProcessingState.NotProcessed, selectable: false },
  { value: PrdProcessingState.ProcessedWithError, selectable: false },
  { value: PrdProcessingState.Processed, selectable: false },
];

@Component({
  selector: 'fl-pilot-form',
  templateUrl: './pilot-form.component.html',
  styleUrls: ['./pilot-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PilotFormComponent implements OnInit {
  @Input()
  public pilot?: PilotViewModel;
  public form: TypedFormGroup<PilotViewModel>;
  public processingStateOptions = PrdProcessingStateSelectItems;

  constructor(private _tfb: TypedFormBuilder, private _route: ActivatedRoute) {}

  public ngOnInit() {
    const airCarrierId = this._route.snapshot.data.airCarrier.id;
    const pilot: Partial<PilotViewModel> = this.pilot != null ? this.pilot : {};
    this.form = this._tfb.group<PilotViewModel>({
      id: [pilot.id],
      airCarrierId: [airCarrierId],
      certificateNumber: [pilot.certificateNumber, Validators.required],
      firstName: [pilot.firstName, Validators.required],
      middleName: [pilot.middleName],
      lastName: [pilot.lastName, Validators.required],
      hidden: [pilot.hidden ?? false],
      lastProcessedDate: [pilot.lastProcessedDate],
      processingError: [pilot.processingError],
      processingState: [pilot.processingState ?? PrdProcessingState.ReadyForTransmission],
    });
  }
}
